var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings-page" }, [
    _c("h2", [_vm._v("Social")]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: { click: _vm.postToFacebook }
          },
          [_vm._v("Post\n                ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", [
        _c(
          "a",
          { attrs: { href: _vm.twitterPostUrl, "data-show-count": "false" } },
          [
            _c(
              "button",
              {
                staticClass: "secondary-btn btn-center",
                attrs: { type: "button" }
              },
              [_vm._v("Post\n                    ")]
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Website")]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row website-integration" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: { click: _vm.copyRegistrationButtonWidget }
          },
          [_vm._v("\n                    Copy code\n                ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row website-integration" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.copyCalendarWidget("classes")
              }
            }
          },
          [_vm._v("\n                    Copy code\n                ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row website-integration" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.copyCalendarWidget("camps")
              }
            }
          },
          [_vm._v("\n                    Copy code\n                ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row website-integration" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.copyCalendarWidget("aftercare")
              }
            }
          },
          [_vm._v("\n                    Copy code\n                ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row website-integration" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.copyActivityListWidget("classes")
              }
            }
          },
          [_vm._v("\n                    Copy code\n                ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row website-integration" }, [
      _vm._m(7),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.copyActivityListWidget("camps")
              }
            }
          },
          [_vm._v("\n                    Copy code\n                ")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "integration-row website-integration" }, [
      _vm._m(8),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "secondary-btn btn-center",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.copyActivityListWidget("aftercare")
              }
            }
          },
          [_vm._v("\n                    Copy code\n                ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: { src: require("../../../assets/img/facebook.svg") }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Facebook")]),
      _vm._v(" "),
      _c("div", { staticClass: "with-tooltip ml-auto" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v("Add a registration link to your Facebook page")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", { attrs: { src: require("../../../assets/img/twitter.svg") } }),
      _vm._v(" "),
      _c("span", [_vm._v("Twitter")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v("Add a registration link to your Twitter page")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Registration button")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v(
            "Add a Registration button to  your website by simply copying and pasting the code"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Class Calendar")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip class-calendar" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v(
            "Add a Class Calendar to your website by simply copying and pasting the code"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Camp Calendar")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip camp-calendar" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v(
            "Add a Camp Calendar to your website by simply copying and pasting the code"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("After Care Calendar")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v(
            "Add a After Care Sessions Calendar to your website by simply copying and pasting the code"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Class list")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip class-list" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v(
            "Add a Class list to  your website by simply copying and pasting the code"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("Camp list")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip camp-list" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v(
            "Add a Camp list to  your website by simply copying and pasting the code"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("After Care list")]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto with-tooltip aftercare-list" }, [
        _c("img", {
          staticClass: "info-img",
          attrs: { src: require("../../../assets/img/info.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "tooltiptext" }, [
          _vm._v(
            "Add a After Care Sessions list to  your website by simply copying and pasting the code"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d8b69d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d8b69d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/settings/Widgets.vue
// module id = null
// module chunks = 